import React, { useEffect } from "react"
import styles from "./Finale.module.scss"
import { withHeaderAndFooter, withCard } from "../../components/hocs"
import { connect } from "react-redux"
import { useNavigate, useSearchParams } from "react-router"
import { AFTER_CONSULT_UPDATE, HOME_PAGE } from "../../core/constants"
import { logout } from "../../services/client/actions"
import config from "react-global-configuration"
import { languages } from "lib/languages"
import mediksanteFinal from "../../assets/images/mediksante_final.svg"

interface FinaleProps {
  logout: () => void
}

const Finale: React.FC<FinaleProps> = (props: FinaleProps) => {
  const [searchParams] = useSearchParams();
  const hasParam = searchParams.has(AFTER_CONSULT_UPDATE);
  const finalTimer = config.get("finalTimer") || 10
  const navigate = useNavigate()
  const { logout } = props

  useEffect(() => {
    logout()
    const timer = setTimeout(() => navigate(HOME_PAGE), finalTimer * 1000)
    return () => clearTimeout(timer)
  }, [logout, navigate, finalTimer])

  return (
    <div className={styles.Finale} data-testid="Finale">
      <h1 className="title-card">Merci !</h1>
      <h2 className="title-card">{hasParam ? languages.change_has_been_made : languages.go_to_the_secretary}
      </h2>
      <img src={mediksanteFinal} alt="mediksante" />
    </div>
  )
}

const FinalePage = withHeaderAndFooter(withCard(Finale))

const mapDispatchToProps = (dispach: Function): FinaleProps => {
  return {
    logout: () => dispach(logout()),
  }
}

export default connect(null, mapDispatchToProps)(FinalePage as any)
